import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Vant from "vant";
import "vant/lib/index.css";

import Wx from 'weixin-js-sdk';

import api from "./utils/http/api";

import DividerImg from "components/DividerImg.vue";
import StickycCta from "components/StickycCta.vue";
import ContainerBox from "components/ContainerBox.vue";
import RowTitle from "components/RowTitle.vue";
import BlockIntroduction from "components/BlockIntroduction.vue";
import CPopup from "components/CPopup.vue";
import BlurMask from "components/BlurMask.vue";

import "lib-flexible/flexible";
import "amfe-flexible";

// 测试 VConsole
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.component('divider-img', DividerImg);
Vue.component('sticky-cta', StickycCta);
Vue.component('container-box', ContainerBox);
Vue.component('row-title', RowTitle);
Vue.component('block-introduction', BlockIntroduction);
Vue.component('c-popup', CPopup);
Vue.component('blur-mask', BlurMask);
Vue.prototype.$wx = Wx;
Vue.prototype.$api = api;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


